import React from "react";
import { Modal, notification, PageHeader } from "antd";
import BeneficiariesTable from "components/BeneficiariesTable";
import { getBeneficiaries, saveBeneficiary, deleteBeneficiary, getCurrentCustomer } from "api/api";
import "./ManageBeneficiariesPage.scss";
import { displayGenericError } from "common/notifications";
import {getOrderStatusByBeneficiaryId, renewAccessToken} from "../../api/api";
import {displayError} from "../../common/notifications";
import {DEFAULT_PAGE_NO, DEFAULT_PAGE_SIZE_10} from "../../common/Const";
import CustomRxPageHeader from "../../rxcomponents/CustomRxPageHeader";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

const confirm = Modal.confirm;

class ManageBeneficiariesPage extends React.Component {
  state = {
    beneficiaries: null,
    isLoading: true,
    currentCustomer: {},
    sortType:'',
    pagination:{
      current: DEFAULT_PAGE_NO,
      size: DEFAULT_PAGE_SIZE_10
    },

  };

  onAddNewBeneficiaryClicked = () => {
    this.setState({
      beneficiaryModalVisible: true,
      addNewBeneficiaryActiveTab: "beneficiaryInformationTab"
    });
  };

  closeBeneficiaryModal = () => {
    this.setState({
      beneficiaryModalVisible: false
    });
  };

  addNewBeneficiaryNextClicked = () => {
    this.setState({
      addNewBeneficiaryActiveTab: "bankAccountTab"
    });
  };

  addNewBeneficiaryBackClicked = () => {
    this.setState({
      addNewBeneficiaryActiveTab: "beneficiaryInformationTab"
    });
  };

  deleteBeneficiary = beneficiary => {
    const intl = this.props.useIntl;
    let canDelete = true;
    getOrderStatusByBeneficiaryId(beneficiary.id)
        .then(response => {
          for (let orderStatus in response) {
            if (response[orderStatus] == "BOOKING"
                || response[orderStatus] == "PROCESSING"
                ||  response[orderStatus] == "DRAFT") {
              canDelete = false;
            }
          }
          if (!canDelete) {
            displayError(intl.formatMessage({id: "app.message.managebeneficiariespage.deletebeneficiarynotallowed"}));
          } else {
            confirm({
              title: intl.formatMessage({id: "app.message.manageoriginatorspage.deletebeneficiary"}),
              onOk: () => {
                this.setState({
                  isLoading: true
                });
                deleteBeneficiary(beneficiary.id)
                    .then(response => {
                      notification.success({
                        message: "Brdgx",
                        description: intl.formatMessage({id: "app.message.managebeneficiariespage.beneficiarydeleted"})
                      });
                      this.setState({
                        isLoading: false
                      });
                      this.refreshBeneficiariesList(this.state.pagination.current);
                    })
                    .catch(error => {
                      displayGenericError(error);
                      this.setState({
                        isLoading: false
                      });
                    });
              }
            });
          }
        })
        .catch(error => {
          displayGenericError(error);
          this.setState({
            isLoading: false
          });
        });

  };

  submitBeneficiary = beneficiary => {
    const intl = this.props.useIntl;
    saveBeneficiary(beneficiary)
      .then(response => {
        notification.success({
          message: "Brdgx",
          description: intl.formatMessage({id: "app.message.managebeneficiariespage.beneficiaryadded"})
        });
        this.setState({
          beneficiaryModalVisible: false,
          beneficiary: {}
        });
        this.refreshBeneficiariesList(this.state.pagination.current);
      })
      .catch(error => {
        displayError(intl.formatMessage({id: "app.message.managebeneficiariespage.couldnotsavebeneficiary"}));
      });
  };

  refreshBeneficiariesList = (currentPage,sortKey,sortType) => {
    const intl = this.props.useIntl;
    if(currentPage>0)
      currentPage=currentPage-1;
    let pagination = this.state.pagination;
    this.setState({
      isLoading: true,
    });
    getBeneficiaries(currentPage, DEFAULT_PAGE_SIZE_10,'','',
        '','',sortKey,sortType)
      .then(response => {
        pagination.total = response.totalElements;
        pagination.current = currentPage+1;

        this.setState({
          isLoading: false,
          beneficiaries: response.content,
          pagination: pagination
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          beneficiaries: []
        });
        displayError(intl.formatMessage({id: "app.message.managebeneficiariespage.couldnotloadbeneficiaries"}));
      });
  };
  renewAccessToken =() =>{
    const intl = this.props.useIntl;
    renewAccessToken( localStorage.getItem("ACCESS_TOKEN")).then(response=>{
      localStorage.setItem("ACCESS_TOKEN", response.accessToken);
    }).catch(error=>{
      if(error.status === 401){
        localStorage.removeItem("ACCESS_TOKEN");
        this.props.handleLogout("/","success", intl.formatMessage({id: "app.message.sessiontimeout"}));
      }
    })
  }
  componentDidMount() {
    this.renewAccessToken();
    this.setState({
      isLoading: true
    });
    this.refreshBeneficiariesList(DEFAULT_PAGE_NO);
    getCurrentCustomer().then(response=>{
      this.setState({
        currentCustomer: response
      });
    });
  }

  changeSortType =() =>{
    let sortType = this.state.sortType;
    if(!sortType) {
      sortType = 'ascend';
    }else {
      if(sortType === 'ascend') {
        sortType = 'descend';
      } else if(sortType === 'descend'){
        sortType = '';
      }
    }

    this.refreshBeneficiariesList(0,'fullName',sortType);

    this.setState({
      sortType:sortType
    })
  }

  onChangePage = (pagination, filters, sorter, extra) => {
    let paginationState = this.state.pagination;
    if(paginationState.current !== pagination.current) {
      let nextPage = pagination.current;
      this.refreshBeneficiariesList(nextPage,'fullName',sorter.order);
    }
  }

  updateBeneficiary = (idx,newBene) =>{
    let beneficiaries = this.state.beneficiaries;
    beneficiaries[idx] = newBene;
    this.setState({
      beneficiaries:beneficiaries
    })
  }

  onBeneficiarySearch =(beneficairy) =>{
    var array = [];
    array.push(beneficairy);
    let pagination = this.state.pagination;
    pagination.total = 1;
    pagination.current = 1;

    this.setState({
      beneficiaries: array,
      pagination: pagination,
      isLoading: false
    });

  }


  render() {
    const intl = this.props.useIntl;
    return (
      <div>
        <CustomRxPageHeader customer={this.props.customer} 
            title={intl.formatMessage({id: "app.sidebar.managebeneficiaries"})} />
        <div className="bp-page-content bp-page-large">

          <BeneficiariesTable
            className="beneficiariesTable"
            sortType={this.state.sortType}
            changeSortType={this.changeSortType}
            data={this.state.beneficiaries}
            pagination = {this.state.pagination}
            onChangePage = {(pagination, filters, sorter, extra) => this.onChangePage(pagination, filters, sorter, extra)}
            onBeneficiarySearch={this.onBeneficiarySearch}
            isLoading={this.state.isLoading}
            onAddNewBeneficiaryClicked={this.onAddNewBeneficiaryClicked}
            onDeleteBeneficiaryClicked={this.deleteBeneficiary}
            onRefresh={this.refreshBeneficiariesList}
            currentCustomer={this.state.currentCustomer}
            updateBeneficiary={(idx,newBene) => this.updateBeneficiary(idx,newBene)}
          />
        </div>
      </div>
    );
  }
}

export default withUseIntl(ManageBeneficiariesPage);